const isDevelopment = process.env.NODE_ENV !== 'production';

const info = (...params: unknown[]) => {
  if (isDevelopment) {
    // eslint-disable-next-line no-console
    console.info(...params);
  }
};
const warn = (...params: unknown[]) => {
  if (isDevelopment) {
    // eslint-disable-next-line no-console
    console.warn(...params);
  }
};
const error = (...params: unknown[]) => {
  // eslint-disable-next-line no-console
  console.error(...params);
};

export const log = {
  info,
  warn,
  error,
};